import {
    PROCESSING_JOB_LIST_REQUEST, PROCESSING_JOB_LIST_SUCCESS, PROCESSING_JOB_LIST_FAIL,
    PROCESSING_JOB_DETAILS_REQUEST, PROCESSING_JOB_DETAILS_SUCCESS, PROCESSING_JOB_DETAILS_FAIL, PROCESSING_JOB_DETAILS_RESET,
    PROCESSING_JOB_CREATE_REQUEST, PROCESSING_JOB_CREATE_SUCCESS, PROCESSING_JOB_CREATE_FAIL, PROCESSING_JOB_CREATE_RESET,
    PROCESSING_JOB_UPDATE_REQUEST, PROCESSING_JOB_UPDATE_SUCCESS, PROCESSING_JOB_UPDATE_FAIL, PROCESSING_JOB_UPDATE_RESET,
    PROCESSING_JOB_DELETE_REQUEST, PROCESSING_JOB_DELETE_SUCCESS, PROCESSING_JOB_DELETE_FAIL,
    PROCESSING_JOB_DTO_REQUEST, PROCESSING_JOB_DTO_SUCCESS, PROCESSING_JOB_DTO_FAIL, PROCESSING_JOB_DTO_RESET,
    PROCESSING_JOB_LIST_BY_IDS_REQUEST, PROCESSING_JOB_LIST_BY_IDS_SUCCESS, PROCESSING_JOB_LIST_BY_IDS_FAIL,
    PROCESSING_JOB_BY_UPLOAD_BATCH_REQUEST, PROCESSING_JOB_BY_UPLOAD_BATCH_SUCCESS, PROCESSING_JOB_BY_UPLOAD_BATCH_FAIL, PROCESSING_JOB_BY_UPLOAD_BATCH_RESET,
    PROCESSING_JOB_BY_STATUS_REQUEST, PROCESSING_JOB_BY_STATUS_SUCCESS, PROCESSING_JOB_BY_STATUS_FAIL,
    PROCESSING_JOB_BY_JOB_TYPE_REQUEST, PROCESSING_JOB_BY_JOB_TYPE_SUCCESS, PROCESSING_JOB_BY_JOB_TYPE_FAIL,
} from '../constants/processingJobConstants';

export const processingJobListReducer = (state = { processingJobs: [] }, action) => {
    switch (action.type) {
        case PROCESSING_JOB_LIST_REQUEST:
            return { loading: true, processingJobs: [] };
        case PROCESSING_JOB_LIST_SUCCESS:
            return {
                loading: false,
                processingJobs: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
                statistics: action.payload.statistics,
            };
        case PROCESSING_JOB_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const processingJobListByIdsReducer = (state = { processingJobs: [] }, action) => {
    switch (action.type) {
        case PROCESSING_JOB_LIST_BY_IDS_REQUEST:
            return { loading: true, processingJobs: [] };
        case PROCESSING_JOB_LIST_BY_IDS_SUCCESS:
            return { loading: false, processingJobs: action.payload,
            };
        case PROCESSING_JOB_LIST_BY_IDS_FAIL:
            return { loading: false, error: action.payload, processingJobs: [] };
        default:
            return state;
    }
};

export const processingJobDetailsReducer = (state = { processingJob: {} }, action) => {
    switch (action.type) {
        case PROCESSING_JOB_DETAILS_REQUEST:
            return { loading: true, ...state };
        case PROCESSING_JOB_DETAILS_SUCCESS:
            return { loading: false, processingJob: action.payload };
        case PROCESSING_JOB_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case PROCESSING_JOB_DETAILS_RESET:
            return { processingJob: {} };
        default:
            return state;
    }
};

export const processingJobDtoReducer = (state = { processingJobDto: {} }, action) => {
    switch (action.type) {
        case PROCESSING_JOB_DTO_REQUEST:
            return { loading: true, processingJobDto: {} };
        case PROCESSING_JOB_DTO_SUCCESS:
            return { loading: false, processingJobDto: action.payload };
        case PROCESSING_JOB_DTO_FAIL:
            return { loading: false, error: action.payload };
        case PROCESSING_JOB_DTO_RESET:
            return { processingJobDto: {} };
        default:
            return state;
    }
};

export const processingJobDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case PROCESSING_JOB_DELETE_REQUEST:
            return { loading: true };
        case PROCESSING_JOB_DELETE_SUCCESS:
            return { loading: false, success: true };
        case PROCESSING_JOB_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const processingJobCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case PROCESSING_JOB_CREATE_REQUEST:
            return { loading: true };
        case PROCESSING_JOB_CREATE_SUCCESS:
            return { loading: false, success: true, processingJob: action.payload };
        case PROCESSING_JOB_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case PROCESSING_JOB_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const processingJobUpdateReducer = (state = { processingJob: {} }, action) => {
    switch (action.type) {
        case PROCESSING_JOB_UPDATE_REQUEST:
            return { loading: true };
        case PROCESSING_JOB_UPDATE_SUCCESS:
            return { loading: false, success: true, processingJob: action.payload };
        case PROCESSING_JOB_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case PROCESSING_JOB_UPDATE_RESET:
            return { processingJob: {} };
        default:
            return state;
    }
};

// Custom reducers for ProcessingJob specific functionality
export const processingJobByUploadBatchReducer = (state = { processingJobsByBatch: {} }, action) => {
    switch (action.type) {
        case PROCESSING_JOB_BY_UPLOAD_BATCH_REQUEST:
            return { 
                ...state,
                loading: true,
                processingJobsByBatch: {
                    ...state.processingJobsByBatch,
                    [action.uploadBatchId]: { loading: true, processingJobs: [] }
                }
            };
        case PROCESSING_JOB_BY_UPLOAD_BATCH_SUCCESS:
            return {
                ...state,
                loading: false,
                processingJobsByBatch: {
                    ...state.processingJobsByBatch,
                    [action.uploadBatchId]: {
                        loading: false,
                        processingJobs: action.payload.items,
                        totalPages: action.payload.totalPages,
                        currentPage: action.payload.currentPage,
                        totalCount: action.payload.totalCount,
                        totalUploadBatchRecords: action.payload.totalUploadBatchRecords,
                        statistics: action.payload.statistics,
                    }
                }
            };
        case PROCESSING_JOB_BY_UPLOAD_BATCH_FAIL:
            return { 
                ...state,
                loading: false,
                processingJobsByBatch: {
                    ...state.processingJobsByBatch,
                    [action.uploadBatchId]: { 
                        loading: false, 
                        error: action.payload, 
                        processingJobs: [] 
                    }
                }
            };
        case PROCESSING_JOB_BY_UPLOAD_BATCH_RESET:
            return { processingJobsByBatch: {} };
        default:
            return state;
    }
};

export const processingJobByStatusReducer = (state = { processingJobs: [] }, action) => {
    switch (action.type) {
        case PROCESSING_JOB_BY_STATUS_REQUEST:
            return { loading: true, processingJobs: [] };
        case PROCESSING_JOB_BY_STATUS_SUCCESS:
            return { loading: false, processingJobs: action.payload };
        case PROCESSING_JOB_BY_STATUS_FAIL:
            return { loading: false, error: action.payload, processingJobs: [] };
        default:
            return state;
    }
};

export const processingJobByJobTypeReducer = (state = { processingJobs: [] }, action) => {
    switch (action.type) {
        case PROCESSING_JOB_BY_JOB_TYPE_REQUEST:
            return { loading: true, processingJobs: [] };
        case PROCESSING_JOB_BY_JOB_TYPE_SUCCESS:
            return { loading: false, processingJobs: action.payload };
        case PROCESSING_JOB_BY_JOB_TYPE_FAIL:
            return { loading: false, error: action.payload, processingJobs: [] };
        default:
            return state;
    }
}; 